import * as S from './styles';

import assets from 'base/src/assets/assets';

import { PageBanner } from 'base/src/components/PageBanner';
import { CarteiraCurrencyInput } from './components/CarteiraCurrencyInput';
import { TipoPagamentoCard } from './components/TipoPagamantoCard';
import PagamentoDestino from './components/PagamentoDestino';
// import { useEffect } from 'react';
import { Button } from 'base/src/components/Button';
import { Modal, ModalContent, ModalTrigger } from 'base/src/components/Modal';
import { RootStateCarteira } from '../../store/carteiraReducer';
import { CalcularImposto, DepositoCredito, DepositoDebito, DepositoPix, GetBoletos, GetMeioPagamento, ResetBoleto, ResetPix } from "domain/store/_carteira/deposito/actions/depositoAction";
import DepositoContainer from '../../containers/deposito/depositoContainer';
import PagamentoPix from './components/ConfirmarPagamento/PagamentoPix';
import usePayment from '../../utils/hooks/usePayment';
import PagamentoBoleto from 'domain/components/_carteira/PagamentoBoleto';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { _UserData, UserDataBaseEnum } from 'base/src/infra/storage/localStorage';
import { useNavigate } from "react-router-dom";

const connector = connectUtil(
  (state: RootStateCarteira) => ({
    impostos: state.DepositoReducer.CalcularImposto,
    meioPagamentos: state.DepositoReducer.GetMeioPagamento,
    CarteiraUsuario: state.CarteiraBaseReducer.CarteiraUsuario,
    BoletoGerado: state.DepositoReducer.BoletoGerado,
  }),
  { DepositoPix, DepositoDebito, DepositoCredito, CalcularImposto, GetMeioPagamento, GetBoletos, ResetBoleto, ResetPix }
);

export interface DepositoComponentProps extends PropsFromRedux<typeof connector> {
}
const _userData = _UserData;
//const Deposito: React.FC<DepositoComponentProps> = (props: DepositoComponentProps) => {

function Deposito(props: DepositoComponentProps) {
  const navigate = useNavigate();
  const depositoContainer = new DepositoContainer(props);

  const {
    paymentState,
    handleValueChange,
    handleSelect,
    handleParcelasUpdate,
  } = usePayment(depositoContainer, props.CarteiraUsuario[0].CarteiraID);


  // useEffect(() => {
  //   depositoContainer.GetMeioPagamento(8);
  // }, []);

  const meiosPagamento = [
    { name: 'PIX', value: 'Taxas PIX à Vista', transacaoTipo: 'PIX', image: assets.pix_icon },
    { name: 'Boleto', value: 'Boleto', transacaoTipo: 'TED', image: assets.codigo_de_barras },
    // { name: 'Crédito', value: 'Cartão de Crédito à Vista', transacaoTipo: 'CREDITO', image: assets.pix_icon },
    // { name: 'Débito', value: 'Cartão de Débito à Vista', transacaoTipo: 'DEBITO', image: assets.pix_icon }
  ]

  const modalWidthMap: Record<string, number | string> = {
    PIX: '35%',
    Débito: 500,
    Crédito: 500,
    Boleto: '90%',
  };



  function handlerRedirect(card: {
    name: string;
    value: string;
    transacaoTipo: string
  }) { //MODELO FINAL
    return () => {
      handleSelect(card.value, card.name, card.transacaoTipo)
    };
  }

  function redirectToHome() {
    navigate('/');
  }


  function modalChange(value: boolean) {
    if (value == true) { return }
    //props.ResetPix();
    //props.ResetBoleto();

    if (props.BoletoGerado !== undefined) {
      redirectToHome()
    }
  }

  return (
    <S.Container>
      <S.TitleContainer>
        <PageBanner title='Depositar' subtile='Realize um depósito' />
      </S.TitleContainer>
      <S.DepositContainer>
        <S.InputContainer>
          <CarteiraCurrencyInput editIcon onValueChange={handleValueChange} />
        </S.InputContainer>
        <S.Subtitle>Selecione o método de pagamento</S.Subtitle>
        <S.Options>
          {meiosPagamento.map((card) => (
            <TipoPagamentoCard
              key={card.name}
              name={card.name}
              image={card.image}
              selected={paymentState.selectedCard === card.value}
              onSelect={handlerRedirect(card)}
            />
          ))}
        </S.Options>

        <S.Subtitle>Para:</S.Subtitle>
        <S.Destino>
          <PagamentoDestino
            impostos={props.impostos}
            tituloImposto={paymentState.selectedCard || ''}
            meioPagamento={props.meioPagamentos}
            onParcelasChange={handleParcelasUpdate}
            nomeUsuario={_userData.Get(UserDataBaseEnum.NomeCompleto)}
            usuarioOwnership={props.CarteiraUsuario[0].Ownership}
            valorDeposito={Number(paymentState.valueForAPI)}
          />
        </S.Destino>

        <Modal onOpenChange={modalChange}>
          <ModalTrigger asChild>
            <Button size='lg' full disabled={!paymentState.selectedCard || Number(paymentState.valueForPayment) <= 0 || Number(paymentState.valueForAPI) <= 0 || paymentState.isCalculating }>Continuar Depósito</Button>
          </ModalTrigger>
          <ModalContent style={{ width: modalWidthMap[paymentState.selectedPagamento || ''] || 500 }}>
            {paymentState.selectedPagamento === 'PIX' && (
              <PagamentoPix
                valorDeposito={Number(paymentState.valueForAPI)}
                valorTotal={Number(paymentState.valueForPayment)}
                meioPagamento={paymentState.selectedPagamento}
                _container={depositoContainer}
              />
            )}
            {/* {paymentState.selectedPagamento === 'Débito' && (
              <PagamentoDebito
                valorDeposito={Number(paymentState.valueForAPI)}
                meioPagamento={paymentState.selectedCard}
                _container={depositoContainer}
              />
            )}
            {paymentState.selectedPagamento === 'Crédito' && (
              <PagamentoCredito
                valorDeposito={Number(paymentState.valueForAPI)}
                meioPagamento={paymentState.selectedPagamento}
                idParcela={paymentState.selectedParcela}
              />
            )} */}
            {paymentState.selectedPagamento === 'Boleto' && (
              <PagamentoBoleto
                valorDeposito={Number(paymentState.valueForAPI)}
                valorTotal={Number(paymentState.valueForPayment)}
                onFinish={redirectToHome}
              />
            )}
          </ModalContent>
        </Modal>
      </S.DepositContainer>
    </S.Container>
  );

}

export default connector(Deposito);